import { OPTIMUM_CONFIG_MORE } from "@middleware/constants";
import { EProgramType, IOrder, IProgram } from "@middleware/types";
import { Tab } from "@middleware/types/global/tabType";
import { Content } from "@prismicio/client";
import { useEffect, useState } from "react";

export const useStepsTabs = (
  defaultStep: Tab,
  steps: Tab[],
  bundle?: IProgram,
  order?: IOrder,
  mealsPageContent?:
    | Content.FlexibilityMealsDocument
    | Content.FlexibilityMealsStagingDocument,
) => {
  const isOptimumProgram = bundle?.productTaxon === EProgramType.OPTIMUM;
  const isActive45Program =
    bundle?.productTaxon === EProgramType.ECO_ACTIVE_45 ||
    bundle?.productTaxon === EProgramType.ORIGINAL_ACTIVE_45;
  const isEnabledOptimumContentTab =
    mealsPageContent?.data.activateOrDeactivate === true;
  const isEnabledActiv45ContentTab =
    mealsPageContent?.data.activateOrDeactivateActive45 === true;
  const defaultSteps =
    order === undefined &&
    ((isOptimumProgram && isEnabledOptimumContentTab) ||
      (isActive45Program && isEnabledActiv45ContentTab))
      ? [...steps, OPTIMUM_CONFIG_MORE]
      : steps;

  const [tabs, setTabs] = useState<Tab[]>(defaultSteps);
  const [prev, setPrev] = useState<Tab>();
  const [currentTab, setCurrentTab] = useState<Tab>(defaultStep);
  const [isLastTab, setIsLastTab] = useState<boolean>(false);

  const getCurrentIndex = (): number => {
    return tabs.findIndex((tab) => tab.id === currentTab.id);
  };
  useEffect(() => {
    const currentIndex = getCurrentIndex();
    if (currentIndex === tabs.length - 1) {
      setIsLastTab(true);
    } else {
      setIsLastTab(false);
    }
    if (currentIndex === 0) {
      setPrev(undefined);
    } else {
      setPrev(tabs[currentIndex - 1]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs, currentTab]);

  const setCurrentTabAsVisited = () => {
    setTabs((prevTabs) =>
      prevTabs.map((prevTab) => {
        if (prevTab.id === currentTab.id) {
          return { ...prevTab, visited: true };
        }

        return prevTab;
      }),
    );
  };

  const setNextTab = () => {
    if (isLastTab) return;
    setCurrentTabAsVisited();
    const nextIndex = getCurrentIndex() + 1;
    setCurrentTab(tabs[nextIndex]);
  };

  const setPrevTab = () => {
    if (getCurrentIndex() === 0) return;
    const prevIndex = getCurrentIndex() - 1;
    setCurrentTab(tabs[prevIndex]);
  };

  const setActiveTab = (tab: Tab) => {
    setCurrentTabAsVisited();
    setCurrentTab(tab);
  };

  return {
    currentTab,
    tabs,
    setActiveTab,
    setNextTab,
    prev,
    setPrevTab,
    isLastTab,
  };
};
